export const initSlick = () => {
  $(".slick-custom").slick({
    // variableWidth: true,
    arrows: true,
    dots: true,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    prevArrow: '<p class="mb-0 prev"><i class="fas fa-arrow-left"></i></p>',
    nextArrow: '<p class="mb-0 next"><i class="fas fa-arrow-right"></i></p>',
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
